export const SET_MAD_CERT_APPLICATION_STATUS = 'SET_MAD_CERT_APPLICATION_STATUS';
